import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { DataServiceService } from "./data-service.service";
import { LoginInfo } from "./model/login";
import { User } from "./model/login";
import { UserDetailsService } from "./user-details.service";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  jwtHelper = new JwtHelperService();
  userName: string;
  private currentUserDetails: User = {
    userId: "",
    companyId: "",
    userName: "",
    email: "",
    password: "",
    totalCreditsEntitled: undefined,
    usedCredits: undefined,
    startDate: undefined,
    endDate: undefined,
    status: "",
    statusRemarks: "",
    userType: "",
    lastLogin: undefined,
    user: "",
    phoneNumber: "",
    companyDetails: [],
    isAdverseMediaEnabled: false
  };

  constructor(
    private router: Router,
    private dataService: DataServiceService
  ) {
    this.setupUser()
  }

  authenticate(loginCredentials: LoginInfo) {
    return this.dataService.getAuthToken(loginCredentials);
  }

  isUserLoggedIn(): boolean {
    if (this.isTokenValid(this.getToken())) {
      this.setCurrentUser();
      return true;
    } else {
      return false;
    }
  }

  isUserAdmin(): boolean {
    if (this.isUserLoggedIn()) {
      if (this.currentUserDetails.userType == "ADMIN" || this.currentUserDetails.userType == "SUPERADMIN" || this.currentUserDetails.userType == "DEVELOPER") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isUserSuperAdmin(): boolean {
    if (this.isUserLoggedIn()) {
      if (this.currentUserDetails.userType == "SUPERADMIN" || this.currentUserDetails.userType == "DEVELOPER") {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  logoutUser(): void {
    localStorage.removeItem("token");
    this.router.navigate(["user-pages/login"]);
  }

  getToken() {
    var token = localStorage.getItem("token") || "";
    return token;
  }

  isTokenValid(token: string = "") {
    if (
      !this.jwtHelper.isTokenExpired(this.getToken()) &&
      this.decryptToken(token)
    ) {
      return true;
    } else {
      return false;
    }
  }

  decryptToken(token) {
    var user = this.jwtHelper.decodeToken(token);
    return user.user;
  }

  getCurrentUser(): User {
    if(this.isUserLoggedIn) return this.currentUserDetails;
  }

  setCurrentUser() {
    const token = this.getToken();
    if(!token) return;
    const isTokenValid = this.isTokenValid(token);
    this.currentUserDetails = this.decryptToken(token);
  }

  setupUser(){
    this.setCurrentUser()
  }
}
